import {BillingSolutionService} from 'services/billingSolutionService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {BillingSolution} from 'types/billingSolution';

export const BillingSolutionThunks = createEntityThunks<BillingSolution>(
  'billingSolution',
  BillingSolutionService,
  {activate: true, deactivate: true},
);
